import { render, staticRenderFns } from "./DefaultPasswordRecoveryEmailComplete.vue?vue&type=template&id=49a24b56&lang=pug&"
import script from "./DefaultPasswordRecoveryEmailComplete.vue?vue&type=script&lang=ts&"
export * from "./DefaultPasswordRecoveryEmailComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports